import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import type { Collection } from "@/types/media";

interface CollectionStripProps {
  items: Collection[];
}

export default function CollectionStrip({ items }: CollectionStripProps) {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <SectionHeading
        title="影视专题合集"
        subtitle="按主题发现更多精彩内容"
        icon="ri-stack-line"
      />
      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2 -mx-4 px-4 md:mx-0 md:px-0">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/search?keyword=${encodeURIComponent(item.query)}`}
            className="group relative shrink-0 w-[260px] md:w-[300px] rounded-lg overflow-hidden bg-background-200"
          >
            <div className="w-full h-[150px] md:h-[170px]">
              <img
                src={item.cover}
                alt={`${item.title}专题封面`}
                title={`${item.title} - 91n影视大全`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <h3 className="font-heading font-bold text-white text-base md:text-lg">{item.title}</h3>
              <p className="text-white/70 text-xs md:text-sm mt-0.5">{item.subtitle}</p>
            </div>
            <span className="absolute top-3 right-3 h-7 px-2.5 rounded-md bg-accent-500 text-background-50 text-xs font-semibold flex items-center gap-1">
              <i className="ri-arrow-right-up-line"></i>
              进入专题
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}